<template>
    <form key="name" @submit.prevent="submit()" @keypress.enter="submit()" class="lc-name-stage form">
        <div class="form__group" :class="{ 'form__group--error' : form.errors.has('team_name') }">
            <label for="team_name" class="form__label">What is your team or company called?</label>
            <input ref="team_name" v-model="form.team_name" id="team_name" name="team_name" class="form__input" placeholder="Gregg Studios" autofocus/>
            <p v-if="form.errors.has('team_name')" class="form__help form__help--error">
                {{ form.errors.get('team_name')}}
            </p>
        </div>
        <div class="form__group" :class="{ 'form__group--error' : form.errors.has('team_url') }">
            <label for="team_url" class="form__label">Your team domain</label>
            <span class="form__sublabel">This will be the url for your skybase account</span>
            <div class="form__row">
                <input v-model="form.team_url" id="team_url" name="team_url" class="form__input" placeholder="gregg-studios"/>
                <span class="form__domain">.skybase.it</span>
            </div>
            <p v-if="form.errors.has('team_url')" class="form__help form__help--error">
                {{ form.errors.get('team_url')}}
            </p>
        </div>
        <div class="form__group" :class="{ 'form__group--error' : form.errors.has('team_size') }">
            <label for="team_size" class="form__label">Team size</label>
            <selector @input="selected" v-model="form.team_size" id="team_size" name="team_size">
                <option value="small">1 - 5</option>
                <option value="medium">6 - 10</option>
                <option value="large">10 - 100</option>
                <option value="xlarge">100+</option>
            </selector>
            <p v-if="form.errors.has('team_size')" class="form__help form__help--error">
                {{ form.errors.get('team_size')}}
            </p>
        </div>

        <button @click="submit" :disabled="form.busy" to="team" type="button" class="button button--primary button--block">Next</button>
    </form>
</template>

<script>
import Form from '../../../helpers/Form'
import Selector from '../../Form/Selector'

export default {
    name: 'TeamStage',

    props: {
        form: {
            type: Form,
            required: true
        }
    },

    mounted() {
        this.$refs.team_name.focus()
    },

    methods: {
        selected(size) {
            this.form.size = size
        },

        submit () {
            this.form.post('/api/registration/validate-team').then(() => {
                this.$router.push('/create/invite')
            })
        },
    },

    components: {
        Selector
    }
}
</script>
